import React from 'react';
import PermissionEditorModal from '../../Components/PermissionEditor/PermissionEditorModal';
import { UsersDataService } from '../../Services/UsersDataService';
import { useSecurity } from '../../Contexts/SecurityContext';
import { Permissions } from '../../Security/permissions';

const UserPermissionsModal = ({ user, onHide, onSaved }) => {
    const { appUser } = useSecurity();
    const loadPermissionSet = React.useCallback(
        token => UsersDataService.getUserPermissions(user.userId, token),
        [user.userId]
    );
    const savePermissionSet = React.useCallback(
        (permissions, token) => UsersDataService.replaceUserPermissions(user.userId, permissions, token),
        [user.userId]
    );

    return (
        <PermissionEditorModal
            permission={Permissions.Security.Users}
            userMode
            title={`Direct permissions - ${user.displayName || user.email}`}
            description="Direct grants add to inherited access; they never remove it. Choose View or View + Execute. Group controls apply to active child resources only."
            loadPermissionSet={loadPermissionSet}
            savePermissionSet={savePermissionSet}
            refreshSecurityAfterSave={user.userId === appUser?.userId}
            onHide={onHide}
            onSaved={onSaved}
        />
    );
};

export default UserPermissionsModal;
